import { useState, useEffect, useRef } from "react"

export default function MobileCarousel() {
  // Sample images - replace with your own URLs
  const images = [
    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FSpeakers%20Page%2FCard%203.png?alt=media&token=381b3f5d-908c-445f-9ab5-5ab36c299f3e",
    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FSpeakers%20Page%2FCard%204.png?alt=media&token=7a6ce379-3807-4dc6-a35f-5542d7469e18",
    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FSpeakers%20Page%2FCard%206.png?alt=media&token=d9202b9b-40c1-461f-a9eb-591391660026",
    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FSpeakers%20Page%2FCard%201.png?alt=media&token=3f397893-9513-4736-a296-04d7180f1257",
    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FSpeakers%20Page%2FCard%202.png?alt=media&token=a3ab145f-c984-4249-ae0b-594635109fb4",
    "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FSpeakers%20Page%2FCard%205.png?alt=media&token=e574c4db-32d7-4163-8d5a-9dd5b3669934",
    // "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FCard.png?alt=media&token=bc53df2d-dbdd-49bc-9c21-70eb192cbf38",
  ]

  const [currentIndex, setCurrentIndex] = useState(0)
  const [isPaused, setIsPaused] = useState(false)
  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)
  const intervalRef = useRef(null)

  // Auto-slide functionality
  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex(prevIndex =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        )
      }, 3000) // 1 second interval
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [images.length, isPaused])

  // Touch handlers for swipe gestures
  const handleTouchStart = (e) => {
    setTouchEnd(null)
    setTouchStart(e.targetTouches[0].clientX)
    setIsPaused(true)
  }

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return
    
    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > 50
    const isRightSwipe = distance < -50

    if (isLeftSwipe) {
      // Swipe left - next slide
      setCurrentIndex(prevIndex =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      )
    } else if (isRightSwipe) {
      // Swipe right - previous slide
      setCurrentIndex(prevIndex =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      )
    }

    setTimeout(() => {
      setIsPaused(false)
    }, 6000)
  }

  // Toggle pause/play on tap
  const handleImageTap = () => {
    setIsPaused(!isPaused)
  }

  // Navigate to specific slide
  const goToSlide = (index) => {
    setCurrentIndex(index)
  }

  const getSlideClass = index => {
    if (index === currentIndex) return "carousel-slide active"
    if (index < currentIndex) return "carousel-slide prev"
    return "carousel-slide next"
  }

  return (
    <>
      <style>{`
        /* Mobile Carousel Styles */
        .carousel-container {
          min-height: 100vh;
          background-image:
            url(https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/HAL%2FProfile%20bg.png?alt=media&token=f221062f-b01e-4338-b6d4-bf50bd12edde);
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          // padding: 1rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .carousel-wrapper {
          width: 100%;
          max-width: 24rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.5rem;
          margin-top:55px;
          animation: fadeIn 0.6s ease-out;
        }

        .carousel-content {
          position: relative;
          aspect-ratio: 1/1.4;
          width: 90%;
          // min-height: 50vh;
          overflow: hidden;
          border-radius: 1rem;
          box-shadow: 2px 2px 7px #08107b;
          touch-action: pan-y pinch-zoom;
          cursor: pointer;
        }

        .carousel-slide {
          position: absolute;
          inset: 0;
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .carousel-slide.active {
          transform: translateX(0);
        }

        .carousel-slide.prev {
          transform: translateX(-100%);
        }

        .carousel-slide.next {
          transform: translateX(100%);
        }

        .carousel-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          user-select: none;
          -webkit-user-drag: none;
        }

        .carousel-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent, transparent);
          pointer-events: none;
        }

        .carousel-indicators {
          position: absolute;
          bottom: 1rem;
          bottom: 15%;
          left: 35%;
          width: 100%;
          transform: translateX(-50%);
          display: flex;
          gap: 0.5rem;
          z-index: 10;
        }

        .indicator {
          height: 0.5rem;
          border-radius: 9999px;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .indicator.active {
          width: 2rem;
          background-color: white;
        }

        .indicator.inactive {
          width: 0.5rem;
          background-color: rgba(255, 255, 255, 0.5);
        }

        .carousel-title-section {
          margin-top: 1.5rem;
          text-align: center;
        }

        .carousel-title {
          font-size: 1.5rem;
          font-weight: bold;
          color: #205370;
          margin-bottom: 0.5rem;
          margin: 0;
        }

        .carousel-subtitle {
          color: #205370;
          font-size: 0.875rem;
          margin: 0.5rem 0 0 0;
        }

        .carousel-counter-section {
          margin-top: 1rem;
          text-align: center;
        }

        .carousel-counter {
          display: inline-block;
          background-color: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(12px);
          border-radius: 9999px;
          padding: 0.5rem 1rem;
          color: #205370;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .play-pause-indicator {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background-color: rgba(0, 0, 0, 0.5);
          color: white;
          border-radius: 50%;
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.875rem;
          z-index: 10;
          transition: opacity 0.3s ease;
        }

        .swipe-hint {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: rgba(255, 255, 255, 0.8);
          background-color: rgba(0, 0, 0, 0.5);
          padding: 0.5rem 1rem;
          border-radius: 1rem;
          font-size: 0.75rem;
          z-index: 10;
          opacity: 0;
          animation: fadeInOut 3s ease-in-out;
          pointer-events: none;
        }

        @keyframes fadeInOut {
          0%, 100% { opacity: 0; }
          50% { opacity: 1; }
        }

        @media (max-width: 480px) {
          .carousel-container {
            padding: 0 0.5rem;
          }
          
          .carousel-wrapper {
            max-width: 100%;
          }
          
          .carousel-title {
            font-size: 1.25rem;
          }
          
          .carousel-subtitle {
            font-size: 0.75rem;
          }

          .play-pause-indicator {
            width: 2rem;
            height: 2rem;
            font-size: 0.75rem;
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div className="carousel-title-section">
            <h1 className="carousel-title">LEADERS CORNER</h1>
          </div>

          {/* Carousel Container */}
          <div 
            className="carousel-content mt-4"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            // onClick={handleImageTap}
          >
            {images.map((image, index) => (
              <div key={index} className={getSlideClass(index)}>
                <img
                  src={image}
                  className="carousel-image"
                  style={{borderRadius: '1rem'}}
                  draggable={false}
                />

                {/* Overlay gradient */}
                <div className="carousel-overlay" />
              </div>
            ))}

            {/* Play/Pause Indicator */}
            {/* <div className="play-pause-indicator">
              {isPaused ? '⏸️' : '▶️'}
            </div> */}

            {/* Swipe hint (shows briefly on first load) */}
            {currentIndex === 0 && (
              <div className="swipe-hint">
               Swipe to navigate
              </div>
            )}

            {/* Progress indicators */}
            <div className="carousel-indicators">
              {images.map((_, index) => (
                <div
                  key={index}
                  className={`indicator ${
                    index === currentIndex ? "active" : "inactive"
                  }`}
                  onTouchEnd={(e) => handleIndicatorTouch(e, index)}
                />
              ))}
            </div>
          </div>

          {/* Title */}
          {/* <div className="carousel-title-section">
            <p className="carousel-subtitle">
              {isPaused ? 'Carousel paused - hold to resume' : 'Auto-sliding every 3 seconds'}
            </p>
          </div> */}

          {/* Current slide counter */}
          <div className="carousel-counter-section">
            <span className="carousel-counter">
              {currentIndex + 1} / {images.length}
            </span>
          </div>
        </div>
      </div>
    </>
  )
}